const modifySubmissionItem = function ({ commit, dispatch }, { field, value }) {
  commit("UPDATE_SUBMISSION", { field, value });
  dispatch("validateSubmission");
};

export default modifySubmissionItem;
